import React, { Component } from "react";
import Switch from "material-ui-next/Switch";

import { withStyles } from "material-ui-next/styles";
import { colors } from "assets";

const Toggle = withStyles({
  bar: {
    backgroundColor: colors.switch.primary,
    opacity: 0.3
  },
  checked: {
    color: colors.switch.primary,
    transform: "translateX(14px)",
    "& + $bar": {
      backgroundColor: colors.switch.primary,
      opacity: 0.5
    }
  }
})(Switch);

class ToggleComponent extends Component {
  render() {
    const checkedToggle = this.props.data ? this.props.data.enabled : false;
    return (
      <Toggle
        checked={checkedToggle}
        onChange={(_, checked) => this.props.onChangeEnabled()}
      />
    );
  }
}

export default ToggleComponent;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/oms/toggle/index.jsx